import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.language = props.intl.locale;
  }

  render() {
    return <div>
      <footer className="footer container" role="contentinfo">
        <div className="region region-footer">
          <section id="block-senaatfooter"
                   className="block block-block-content block-block-content9ad51b82-178b-451e-82c8-cb14c7de108c clearfix">
            <div className="field field--name-body field--type-text-with-summary field--label-hidden field--item"><p>©
              <FormattedMessage id="belgianSenate"/> - SenLex</p>
            </div>
          </section>

          <nav role="navigation" aria-labelledby="block-senaat-bootstrap-footer-menu"
               id="block-senaat-bootstrap-footer">
            <ul className="menu nav">
              <li className="expanded dropdown">
                <a href={"/" + this.props.intl.locale + "/disclaimer"} data-drupal-link-system-path="node/2">Disclaimer</a>
              </li>
            </ul>
          </nav>
        </div>
      </footer>
    </div>
  }
}

function mapStateToProps(state) {
  const {intl} = state;
  return {
    intl
  };
}

export default connect(mapStateToProps)(Footer);



/** WEBPACK FOOTER **
 ** ./src/modules/app/components/Footer.js
 **/